import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs?: Crumb[];
}

export default function PageHero({ eyebrow, title, description, crumbs }: PageHeroProps) {
  return (
    <section className="relative w-full bg-primary-950 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.14]">
        <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-accent-500 blur-3xl"></div>
        <div className="absolute -bottom-32 left-1/4 w-80 h-80 rounded-full bg-secondary-500 blur-3xl"></div>
      </div>
      <div className="relative w-full px-4 md:px-6 pt-28 md:pt-32 pb-10 md:pb-14">
        {crumbs && crumbs.length > 0 && (
          <nav className="flex flex-wrap items-center gap-2 text-xs text-background-300 mb-4">
            {crumbs.map((c, i) => (
              <span key={`${c.label}-${i}`} className="inline-flex items-center gap-2">
                {c.to ? (
                  <Link to={c.to} className="hover:text-accent-400 transition-colors">
                    {c.label}
                  </Link>
                ) : (
                  <span className="text-background-100">{c.label}</span>
                )}
                {i < crumbs.length - 1 && (
                  <i className="ri-arrow-right-s-line text-background-400" aria-hidden="true"></i>
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-accent-400 mb-3">
            <span className="w-6 h-px bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight max-w-4xl">
          {title}
        </h1>
        {description && (
          <p className="mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-background-200">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}